import {PermissionsModel} from '../../../entity/permissions.model';

export class PermissionUtils {
    // To refactor later
    static getPermission(entity: any): PermissionsModel {
        let permissions = entity?.permissions;
        if (!permissions) {
            permissions = entity?.summary?.permissions;
        }
        if (permissions) {
            return {
                deletable: permissions?.deletable,
                updatable: permissions?.updatable,
                permissions: permissions?.permissions
            };
        }
        return undefined;
    }
}
